var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Functions = OCS.Functions || {};
// Requires OCS.Classes.Utilities.base
OCS.Functions.define_image_obj = function () {
    return new Class({
        Implements: [Options, Events],
        class_type: "image_obj",
        class_name: "image_obj",
        item: null,
        container: null,
        refresh_process: null,
        req: null,
        options: {
            refresh_image: false,
            handle_sizing: false,
            original_width: 0,
            original_height: 0,
            constrained_width: 0,
            constrained_height: 0,
            lock_constraint_size: false, // Prevent future tampering of the constraint size. Prevents resize events from making any difference in the image
            container_selector: ".image_container",
            expire_time: 0,
            failed_attempts: 0,
            failed_attempts_allowed: 15,
            domain_only: 'www.mesonet.org',
            error: {
                codes: {
                    to_many_failures: 'failed',
                    not_allowed: 'not_allowed',
                    unknown: 'unknown'
                },
                text: {
                    to_many_failures: 'To many failed attempts',
                    not_allowed: 'Not allowed access',
                    unknown: 'Failed to check for updates for unknown reasons'
                }
            },
            image_loaded: 0, // Epoch time for last time image was loaded
            image_update_url: '', // Url of the image to update
            image_update_frequency: 120000 // How frequently to update the image, defaults to 2 minutes in milliseconds
        },
        start_timeout: null,
        bound_methods: {},
        am: null,
        /**
         * 
         * @param {Mootools Element} item 
         * @param {Object} op
         * @returns {OCS.Functions.define_image_obj.image_objAnonym$0.initialize.obj|Class.Functions.define_image_obj.image_objAnonym$0.initialize.obj|Object|Boolean}
         */
        initialize: function (item, op) {
            if (!item) {
                return false;
            }
            var obj = item.retrieve("image_obj");
            if (obj && obj.class_name === this.class_name) {
                return obj;
            }
            if (!op) {
                op = {};
            }
            var i_ops = item.get('data-options');
            if (i_ops) {
                try {
                    i_ops = JSON.parse(i_ops);
                } catch (e) {
                    i_ops = {};
                }
                if (Object.keys(i_ops).length > 0) {
                    this.setOptions(i_ops);
                }
            }

            this.bound_methods.image_on_resize = this.image_on_resize.bind(this);
            this.bound_methods.image_on_click = this.on_click_image.bind(this);
            this.bound_methods.image_on_drag = this.image_on_drag.bind(this);
            this.bound_methods.on_update_success = this.on_update_success.bind(this);
            this.bound_methods.on_update_error = this.on_update_error.bind(this);
            this.bound_methods.on_start_refresh_process = this.on_start_refresh_process.bind(this);
            this.bound_methods.on_stop_refresh_process = this.on_stop_refresh_process.bind(this);
            this.bound_methods.on_load_image = this.image_onload.bind(this);
            this.item = item;
            this.setOptions(op);
            this.set_container();
            this.am = new OCS.Classes.OCSAjaxManager({storeCompletedReq: 0});
            var url;
            /* istanbul ignore else */
            if (!this.options.image_update_url) {
                this.options.image_update_url = this.item.getProperty('src');
            } 
            url = this.options.image_update_url;
            
            this.req = this.am.request(url, {
                url: url,
                method: "head",
                emulation: false
            });

            this.initialize_events();

            if (this.options.handle_sizing) {
                if (!this.options.lock_constraint_size) {
                    window.addEvent('resize', this.bound_methods.image_on_resize);
                }
            }
            if (this.item.complete) {
                this.update_image_size();
                this.image_size_constrain();
            } else {
                this.item.addEvent('load', this.bound_methods.on_load_image);
            }
            this.item.store("image_obj", this);
            this.item.set('data-options', JSON.stringify(this.options));
            if (this.options.refresh_image) {
                this.start_timeout = setTimeout(this.bound_methods.on_start_refresh_process, 1);
            }


        },
        initialize_events: function () {
            if (this.req) {
                this.req.addEvent('success', this.bound_methods.on_update_success);
                this.req.addEvent('failure', this.bound_methods.on_update_error);
            }
            this.addEvent('start_data_refresh', this.bound_methods.on_start_refresh_process);
            this.addEvent('stop_data_refresh', this.bound_methods.on_stop_refresh_process);
            if (this.item) {
                this.item.addEvent('click', this.bound_methods.image_on_click);
                this.item.addEvent('dragstart', this.bound_methods.image_on_drag);
            }
        },

        /*
         * Action methods
         */

        set_container: function (cont) {
            if (cont) {
                this.container = cont;
            } else {
                if(this.options.container_selector) {
                    cont = this.item.getParent(this.options.container_selector);
                } else {
                    cont = this.item.getParent();
                    cont.addClass(this.options.container_selector.replace('.', ''));
                }
                if (!cont) {
                    cont = document.id(document.body);
                }
                this.container = cont;
            }
            this.update_constraint_size();
            this.image_size_constrain();
        },
        image_on_resize: function (e) {
            this.update_constraint_size();
            this.image_size_constrain();
            this.fireEvent('image_resized', this);
        },

        image_on_drag: function (e) {
            e.preventDefault();
        },
        image_onload: function () {
            if (this.item) {
                this.item.removeEvent('load', this.bound_methods.on_load_image);
                this.options.image_loaded = new Date().valueOf();
                this.update_image_size();
                this.image_size_constrain();
                this.fireEvent('image_loaded', this);
            }
        },
        image_size_constrain: function () {
            if (this.options.handle_sizing && !this.item.hasClass('original')) {
                if (this.options.constrained_height === 0 && this.options.constrained_width === 0) {
                    this.item.setStyle('width', 'auto').setStyle('height', 'auto');
                    return;
                }

                var height = this.options.original_height;
                var width = this.options.original_width;
                var ratio = this.options.original_width / this.options.original_height;
                if (width > this.options.constrained_width) {
                    width = this.options.constrained_width;
                    height = Math.floor(this.options.constrained_width / ratio);
                }
                if (height > this.options.constrained_height) {
                    height = this.options.constrained_height;
                    width = Math.floor(this.options.constrained_height * ratio);
                }
                this.item.setStyle('width', width).setStyle('height', height);
            }
        },
        image_update: function () {
            var current_time = new Date().valueOf();
            if (this.options.expire_time !== 0 && current_time > this.options.expire_time) {
                this.fireEvent('image_expired', this);
            }
            this.req.send();
        },

        update_constraint_size: function () {
            if (!this.options.lock_constraint_size) {
                var dim = this.container.getCoordinates();
                this.options.constrained_height = dim.height;
                this.options.constrained_width = dim.width;
            }
        },
        update_image_size: function () {
            if (this.options.handle_sizing) {
                this.item.setStyle('width', 'auto').setStyle('height', 'auto');
            }
            if (this.options.original_width === 0 && this.options.original_height === 0) {
                var dim = this.item.getCoordinates();
                this.options.original_width = dim.width;
                this.options.original_height = dim.height;
            }
        },

        get_url_domain: function() {
            var domain;
            if (this.options.image_update_url.indexOf("://") > -1 || this.options.image_update_url.indexOf("//") === 0) {
                domain = this.options.image_update_url.split('/')[2];
            } else {
                domain = this.options.image_update_url.split('/')[0];
            }
            //find & remove port number
            domain = domain.split(':')[0];
            return domain;
        },
        get_failed_update_response: function(response) {
            var resp = {reason: this.options.error.text.unknown, code: this.options.error.codes.unknown};
            var domain = this.get_url_domain();
            if (domain === this.options.domain_only || domain === '') {
                if (response.failed_attempts > this.options.failed_attempts_allowed) { // After unsuccessful attempts greater than this.options.failed_attempts, send a stop message back to the callback function.
                    resp = {
                        attemps: response.failed_attempts,
                        reason: this.options.error.text.to_many_failures,
                        code: this.options.error.codes.to_many_failures
                    };
                }
            } else {
                resp = {reason: this.options.error.text.not_allowed, code: this.options.error.codes.not_allowed};
            }
            delete response.request.response;
            return resp;
        },

        /*
         * Event Listeners
         */
        on_click_image: function (e) {
            if (this.item.hasClass('original')) {
                // We clicked after applying the original sizing, so we need to revert to the constrained size.
                this.item.removeClass('original');
                this.image_size_constrain();
                this.container.removeClass('scrollable');
            } else {
                // We clicked and need to apply the original sizing
                this.item.setStyle('width', this.options.original_width).setStyle('height', this.options.original_height);
                this.container.addClass('scrollable');
                this.item.addClass('original');
            }
            this.fireEvent('image_clicked', this);
        },
        on_start_refresh_process: function () {
            if (this.start_timeout) {
                clearTimeout(this.start_timeout);
                this.start_timeout = null;
            }
            if (!this.refresh_process && this.options.image_update_frequency) {
                this.refresh_process = setInterval(this.image_update.bind(this), this.options.image_update_frequency);
                this.fireEvent('refresh_process', [this, {'status': 'active'}]);
            }
        },
        on_stop_refresh_process: function () {
            if (this.refresh_process) {
                clearInterval(this.refresh_process);
                this.refresh_process = null;
                this.fireEvent('refresh_process', [this, {'status': 'inactive'}]);
            }
        },
        on_update_success: function (response) {
            if (!this.options.image_update_url) {
                this.options.image_update_url = response.request.options.url;
            }

            var lastUpdatedTimestamp = response.request.getHeader('Last-Modified');
            if (lastUpdatedTimestamp) {
                var lastUpdatedTimestampEpoch = new Date(lastUpdatedTimestamp).getTime();
                if (this.options.image_loaded < lastUpdatedTimestampEpoch) {
                    var op = {// reset options with new timestamp
                        'image_loaded': lastUpdatedTimestampEpoch
                    };
                    this.setOptions(op);
                    this.fireEvent('new_image_available', this);
                }
            }
            delete response.request.response;
            this.fireEvent('success', this);
        },
        on_update_error: function (response) {
            this.fireEvent('error', [this, this.get_failed_update_response(response)]);
        },

        destroy: function () {
            /* istanbul ignore if */
            if (this.start_timeout) {
                clearTimeout(this.start_timeout);
                this.start_timeout = null;
            }
            if (this.options.handle_sizing) {
                window.removeEvent('resize', this.bound_methods.image_on_resize);
            }
            if (this.item) {
                this.item.removeEvent('load', this.bound_methods.on_load_image);
                this.item.removeEvent('click', this.bound_methods.image_on_click);
                this.item.removeEvent('dragstart', this.bound_methods.image_on_drag);
                this.item.store("image_obj", null);
            }
            if (this.req) {
                this.req.destroy();
            }
            if(this.am) {
                this.am.remove_request(this.options.image_update_url);
                this.am = null;
            }          
            this.removeEvents();
            this.on_stop_refresh_process();

            this.item = null;
            this.container = null;
        }
    });
};
OCS.Classes.OCSImageObj = OCS.Functions.define_image_obj();
